import { EERIE, GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
import Small from 'UIComponents/elements/Small';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BrowserUrlDisplay = ({
  url
}) => {
  if (!url) return null;
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    justify: "start",
    direction: "row",
    style: {
      backgroundColor: GREAT_WHITE,
      borderRadius: '8px'
    },
    children: [/*#__PURE__*/_jsx(UIBox, {
      className: "p-all-2",
      shrink: 0,
      children: /*#__PURE__*/_jsx(UIIcon, {
        color: EERIE,
        name: "home",
        size: 22
      })
    }), /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      style: {
        backgroundColor: OLAF,
        borderRadius: '3px'
      },
      className: "m-y-2 m-right-3 p-all-1",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        className: "m-left-1",
        color: EERIE,
        name: "locked",
        size: 12
      }), /*#__PURE__*/_jsx(Small, {
        className: "m-left-2",
        children: /*#__PURE__*/_jsx(UITruncateString, {
          matchContentWidth: true,
          children: url
        })
      })]
    })]
  });
};
export default BrowserUrlDisplay;